module.exports = __webpack_public_path__ + "static/media/ticket-pendiente.5cfdf921.png";